import Vue from "vue"
import VueRouter from "vue-router"
import Overview from "../views/overview.vue"
import store from "../store/index"
Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    alias: "/overview",
    name: "Overview",
    component: Overview
  },
  {
    path: "/users/addUser/:userId?",
    name: "AddUser",
    component: () => import("@/views/team/_role/adduser")
  },
  {
    path: "/clients/manageClients",
    name: "ManageClients",
    component: () => import("@/views/clients/manageClients")
  },
  {
    path: "/Authentication/Login",
    name: "Login",
    meta: { layout: "authentication" },
    component: () => import("@/views/authentication/login")
  },
  {
    path: "/Authentication/ResetPassword/:token",
    name: "ResetPassword",
    meta: { layout: "authentication" },
    component: () => import("@/views/authentication/resetPassword")
  },
  {
    path: "/Clients",
    name: "Clients",
    component: () => import("@/views/clients/clients")
  },
  {
    path: "/Client/:clientId",
    name: "Client",
    props: route => ({ quote: route.query.q }),
    component: () => import("@/views/clients/client")
  },
  {
    path: "/Team/User/:user",
    name: "User",
    component: () => import("@/views/team/user")
  },
  {
    path: "/Team",
    name: "Team",
    component: () => import("@/views/team/team")
  },
  {
    path: "/TimeLogs/TimeLogs",
    name: "TimeLogs",
    component: () => import("@/views/timeLogs/timeLogs")
  },
  {
    path: "/TimeLogs/UserTimelogs/:clientId?",
    name: "UserTimelogs",
    component: () => import("@/views/timeLogs/userTimeLogs")
  },
  {
    path: "/TimeLogs/ClientSummary/:clientId?",
    name: "ClientSummary",
    component: () => import("@/views/timeLogs/clientSummary")
  },
  {
    path: "/Users/ManageUsers",
    name: "ManageUsers",
    component: () => import("@/views/team/manageUsers")
  },
  {
    path: "/Reports/Quotes",
    name: "QuotesReport",
    component: () => import("@/views/reports/quotesReport")
  },
  {
    path: "/Leave/Apply/:userId?",
    name: "ApplyLeave",
    component: () => import("@/views/leave/apply")
  },
  {
    path: "/Leave/Summary/:month?",
    name: "LeaveSummary",
    component: () => import("@/views/leave/summary")
  },
  {
    path: "/Leave/Recipients",
    name: "LeaveRecipients",
    component: () => import("@/views/leave/recipients")
  },
  {
    path: "/Leave/Grid",
    name: "LeaveGrid",
    component: () => import("@/views/leave/grid")
  },
  {
    path: "/StaticPages/ReleaseNotes",
    name: "ReleaseNotes",
    component: () => import("@/views/staticpages/releasenotes")
  },
  {
    path: "/Reports/FlashReport",
    name: "FlashReport",
    component: () => import("@/views/reports/flashReport")
  },
  {
    path: "/Reports/resourceSheetReport",
    name: "ResourceSheetReport",
    component: () => import("@/views/reports/resourceSheetReport")
  }
]

const router = new VueRouter({
  routes
})
//Authentication Guard
router.beforeEach((to, from, next) => {
  //Allow access to Login/ResetPassword views
  if (
    to.name !== "Login" &&
    to.name !== "ResetPassword" &&
    !store.state.users.currentUser
  ) {
    next({ name: "Login" })
  } else next()
})

export default router
